import { action } from 'mobx';
import useStore from "./useStore.js";
export var useSort = () => {
  var store = useStore();
  return [store.sort, action('updateSort', update => store.updateSort(update))];
};
export default useSort;
//# sourceMappingURL=useSort.js.map